import * as Updates from 'expo-updates'
import { Platform } from 'react-native'

function getWebApiUrl(nativeUrl: string): string {
  // For web, use BFF proxy on web app domain instead of direct API calls
  if (Platform.OS === 'web') {
    // Production API
    if (nativeUrl.includes('napi.nextforce.us')) {
      return 'https://api.nextforcetechnology.com/api'
    }
    // Staging API (includes local dev pointing to staging and Amplify PRs)
    if (nativeUrl.includes('nstg.nextforce.us')) {
      return 'https://api-staging.nextforcetechnology.com/api'
    }
  }
  return nativeUrl
}

const ENV = {
  development: {
    name: 'development',
    SERVER_API_URL: getWebApiUrl('https://nstg.nextforce.us'),

    FRESHCHAT_HELPER: 'b7532c0f-bab6-4d56-a8b2-aebf1013dff0',
    FRESHCHAT_MANAGER: '2ca6b266-2864-407f-941c-7fb102f9b2b3',
    FRESHCHAT_MANAGER_APP_ID: 'c667880e-f481-43be-a962-2cf4ed578975',
    FRESHCHAT_MANAGER_APP_KEY: '0ff850f7-456c-4a92-95a4-70c24cbe90bf',
    FRESHCHAT_HELPER_APP_ID: 'e2884578-6d2e-4ca7-958e-8cd24cc93eed',
    FRESHCHAT_HELPER_APP_KEY: 'a6df008b-ae03-4900-8b0c-64daba9195ae',

    SENTRY_ORG: 'next-force-technology',
    SENTRY_PROJECT: 'app3',
    WEBSOCKETS_ENV: 'staging',
  },
  staging: {
    name: 'staging',
    SERVER_API_URL: getWebApiUrl('https://nstg.nextforce.us'),

    FRESHCHAT_HELPER: 'b7532c0f-bab6-4d56-a8b2-aebf1013dff0',
    FRESHCHAT_MANAGER: '2ca6b266-2864-407f-941c-7fb102f9b2b3',
    FRESHCHAT_MANAGER_APP_ID: 'c667880e-f481-43be-a962-2cf4ed578975',
    FRESHCHAT_MANAGER_APP_KEY: '0ff850f7-456c-4a92-95a4-70c24cbe90bf',
    FRESHCHAT_HELPER_APP_ID: 'e2884578-6d2e-4ca7-958e-8cd24cc93eed',
    FRESHCHAT_HELPER_APP_KEY: 'a6df008b-ae03-4900-8b0c-64daba9195ae',

    SENTRY_ORG: 'next-force-technology',
    SENTRY_PROJECT: 'app3',
    WEBSOCKETS_ENV: 'staging',
  },
  production_internal: {
    name: 'production_internal',
    SERVER_API_URL: getWebApiUrl('https://napi.nextforce.us'),

    FRESHCHAT_HELPER: 'b7532c0f-bab6-4d56-a8b2-aebf1013dff0',
    FRESHCHAT_MANAGER: '2ca6b266-2864-407f-941c-7fb102f9b2b3',
    FRESHCHAT_MANAGER_APP_ID: 'c667880e-f481-43be-a962-2cf4ed578975',
    FRESHCHAT_MANAGER_APP_KEY: '0ff850f7-456c-4a92-95a4-70c24cbe90bf',
    FRESHCHAT_HELPER_APP_ID: 'e2884578-6d2e-4ca7-958e-8cd24cc93eed',
    FRESHCHAT_HELPER_APP_KEY: 'a6df008b-ae03-4900-8b0c-64daba9195ae',

    SENTRY_ORG: 'next-force-technology',
    SENTRY_PROJECT: 'app3',
    WEBSOCKETS_ENV: 'prod',
  },
  staging_production_internal: {
    name: 'staging',
    SERVER_API_URL: getWebApiUrl('https://nstg.nextforce.us'),

    FRESHCHAT_HELPER: 'b7532c0f-bab6-4d56-a8b2-aebf1013dff0',
    FRESHCHAT_MANAGER: '2ca6b266-2864-407f-941c-7fb102f9b2b3',
    FRESHCHAT_MANAGER_APP_ID: 'c667880e-f481-43be-a962-2cf4ed578975',
    FRESHCHAT_MANAGER_APP_KEY: '0ff850f7-456c-4a92-95a4-70c24cbe90bf',
    FRESHCHAT_HELPER_APP_ID: 'e2884578-6d2e-4ca7-958e-8cd24cc93eed',
    FRESHCHAT_HELPER_APP_KEY: 'a6df008b-ae03-4900-8b0c-64daba9195ae',

    SENTRY_ORG: 'next-force-technology',
    SENTRY_PROJECT: 'app3',
    WEBSOCKETS_ENV: 'staging',
  },
  production: {
    name: 'production',
    SERVER_API_URL: getWebApiUrl('https://napi.nextforce.us'),

    FRESHCHAT_HELPER: 'b7532c0f-bab6-4d56-a8b2-aebf1013dff0',
    FRESHCHAT_MANAGER: '2ca6b266-2864-407f-941c-7fb102f9b2b3',
    FRESHCHAT_MANAGER_APP_ID: 'c667880e-f481-43be-a962-2cf4ed578975',
    FRESHCHAT_MANAGER_APP_KEY: '0ff850f7-456c-4a92-95a4-70c24cbe90bf',
    FRESHCHAT_HELPER_APP_ID: 'e2884578-6d2e-4ca7-958e-8cd24cc93eed',
    FRESHCHAT_HELPER_APP_KEY: 'a6df008b-ae03-4900-8b0c-64daba9195ae',

    SENTRY_ORG: 'next-force-technology',
    SENTRY_PROJECT: 'app3',
    WEBSOCKETS_ENV: 'prod',
  },
}

export function getReleaseChannel(): string | undefined | null {
  if (Platform.OS === 'web') {
    return process.env.RELEASE_CHANNEL
  }
  return Updates.channel
}

export default function getEnvironment() {
  switch (getReleaseChannel()) {
    case 'production':
      return ENV.production

    case 'production_internal':
      return ENV.production_internal

    case 'staging':
      return ENV.staging

    case 'staging_production_internal':
      return ENV.staging_production_internal

    default:
      return ENV.development
  }
}
